export default "__VITE_ASSET__DOgTDF0u__"